import React, { useState, useEffect } from 'react';
import { supabase } from '../lib/supabase';
import MaintenancePage from '../pages/MaintenancePage';

/**
 * MaintenanceGuard
 * - ดึงค่า maintenance_mode จาก system_config
 * - ถ้า true + user ไม่ใช่ admin → แสดง MaintenancePage
 * - ถ้า true + user เป็น admin → ผ่านปกติ
 * - ถ้า false → ผ่านปกติ
 */
const MaintenanceGuard = ({ children }) => {
  const [isMaintenance, setIsMaintenance] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);
  const [maintenanceMessage, setMaintenanceMessage] = useState('');
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    const check = async () => {
      try {
        // ดึง maintenance_mode + maintenance_message พร้อมกัน
        const { data: configData } = await supabase
          .from('system_config')
          .select('key, value')
          .in('key', ['maintenance_mode', 'maintenance_message']);

        const configMap = {};
        (configData || []).forEach((row) => { configMap[row.key] = row.value; });

        const maintenanceOn = configMap.maintenance_mode === 'true';
        setIsMaintenance(maintenanceOn);
        setMaintenanceMessage(configMap.maintenance_message || '');

        // ถ้า maintenance เปิด → เช็ค role จาก Supabase โดยตรงเสมอ (ไม่ trust sessionStorage)
        if (maintenanceOn) {
          const { data: { user } } = await supabase.auth.getUser();
          if (user) {
            const { data: profile } = await supabase
              .from('user_profiles')
              .select('role')
              .eq('id', user.id)
              .single();

            if (profile?.role === 'admin') {
              setIsAdmin(true);
            }
          }
        }
      } catch (err) {
        console.error('Error checking maintenance mode:', err);
      } finally {
        setChecking(false);
      }
    };

    check();
  }, []);

  // กำลังเช็ค → ไม่แสดงอะไร (กัน flash)
  if (checking) return null;

  // maintenance + ไม่ใช่ admin → block
  if (isMaintenance && !isAdmin) {
    return <MaintenancePage message={maintenanceMessage} />;
  }

  return children;
};

export default MaintenanceGuard;
